import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowRight } from "lucide-react";
import { api } from "../lib/api";

function projectHref(p) {
  if (p.link && p.link.trim()) return p.link.trim();
  return `/progetti/${p.slug}`;
}
function isExternal(href) {
  return /^https?:\/\//i.test(href);
}

function ProjectCard({ p }) {
  const href = projectHref(p);
  const ext = isExternal(href);

  const cover = p.image ? (
    <div className="aspect-[4/3] overflow-hidden bg-[#F9FAFB] flex items-center justify-center">
      <img
        src={p.image}
        alt={p.title}
        className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700"
      />
    </div>
  ) : (
    <div className="aspect-[4/3] bg-gradient-to-br from-[#007A3D] via-[#00A651] to-[#0F1A14] flex items-center justify-center p-6 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-25"
        style={{ backgroundImage: "radial-gradient(circle at 20% 20%, rgba(255,255,255,0.4) 0%, transparent 55%)" }}
      />
      <span className="relative font-display font-black tracking-tighter text-white text-4xl md:text-5xl text-center leading-none">
        {p.title}
      </span>
    </div>
  );

  const inner = (
    <>
      {cover}
      <div className="p-6 md:p-7 flex flex-col flex-1">
        <h3 className="font-display font-bold text-xl md:text-2xl text-[#1A1A1A] tracking-tight leading-snug">
          {p.title}
        </h3>
        {p.short_desc && (
          <p className="mt-3 text-sm text-[#6B7280] leading-relaxed line-clamp-3">{p.short_desc}</p>
        )}
        <span className="mt-5 inline-flex items-center gap-1.5 text-[#007A3D] font-medium text-sm group-hover:gap-2.5 transition-all">
          Scopri di più {ext ? <ArrowUpRight className="w-4 h-4" /> : <ArrowRight className="w-4 h-4" />}
        </span>
      </div>
    </>
  );

  const cls =
    "group bg-white rounded-3xl border border-[#E5E7EB] overflow-hidden hover-lift flex flex-col";

  return ext ? (
    <a href={href} target="_blank" rel="noopener noreferrer" data-testid={`progetto-card-${p.slug}`} className={cls}>
      {inner}
    </a>
  ) : (
    <Link to={href} data-testid={`progetto-card-${p.slug}`} className={cls}>
      {inner}
    </Link>
  );
}

export default function Blog() {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="page-progetti">
      <section className="pt-24 md:pt-32 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-[#007A3D]">Progetti</span>
          <h1 className="mt-5 font-display font-black tracking-tighter text-4xl sm:text-5xl md:text-6xl leading-[1.02] text-[#1A1A1A] max-w-4xl">
            I nostri progetti per le imprese agricole in Sardegna.
          </h1>
          <p className="mt-6 text-lg text-[#6B7280] max-w-2xl">
            Iniziative, bandi e progettualità con cui Betelgez accompagna la crescita del mondo agricolo sardo.
          </p>
        </div>
      </section>
      <section className="pb-24 md:pb-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {projects.length === 0 ? (
            <div className="text-center py-16 text-[#6B7280]">Nessun progetto pubblicato al momento.</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {projects.map((p) => (
                <ProjectCard key={p.slug} p={p} />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
